// extracted by mini-css-extract-plugin
export default {"bottomFixedContentWrapper":"G0d8b5f"};